import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button, SwitcherButtonProps } from "components/buttons/Button";
import SwitcherLogo from "assets/SwitcherPlayerIconGradient.svg?react";
import styles from "./index.module.scss";
import { useNavigate } from "react-router-dom";

export const ErrorPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleBackToHome = useCallback(() => {
        navigate("/");
    }, [navigate]);

    const actions = useMemo<SwitcherButtonProps[]>(
        () => [
            {
                children: t("error:action:back-to-home"),
                onClick: handleBackToHome
            }
        ],
        [handleBackToHome, t]
    );

    return (
        <section className={styles["error-page"]}>
            <SwitcherLogo />
            <div className={styles["error-page-container"]}>
                <h1>{t("error:not-found:header")}</h1>
                <h4>{t("error:subheader")}</h4>
                <p>{t("error:description")}</p>
                <div className={styles["actions-container"]}>
                    {actions.map((props, index) => (
                        <Button key={index} {...props} />
                    ))}
                </div>
            </div>
        </section>
    );
};
